import { render, staticRenderFns } from "./UserSendNotificationAction.vue?vue&type=template&id=f78ba6c4"
import script from "./UserSendNotificationAction.vue?vue&type=script&lang=js"
export * from "./UserSendNotificationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports